import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAuthRedirect = () => {
  const query = useQuery();

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'io.practist.google.authRedirect',
          queryParams: Array.from(query.entries()),
        },
        '*',
      );
      window.close();
    }
  }, []);

  return (
    <div
      style={{
        backgroundColor: 'var(--mantine-color-gray-0)',
        width: '100%',
        height: '100%',
      }}
    ></div>
  );
};

export default GoogleAuthRedirect;

function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}
